module.exports = __webpack_public_path__ + "img/symbol_8.2b5f9e1e.png";